export default "__VITE_ASSET__d598e4ad__"